import api from './client';
import type { FiltrosCatalogo, GerarCatalogoResponse } from '../types/catalogo';
import { logError } from '../utils/clientLog';

export interface CatalogoHistorico {
  id: number;
  nomeArquivo: string;
  tamanhoBytes: number;
  geradoPor?: string;
  criadoEm: string;
}

class CatalogoService {

  async listarHistorico(): Promise<CatalogoHistorico[]> {
    const response = await api.get<CatalogoHistorico[]>('/catalogo/historico');
    return response.data;
  }

  async excluirCatalogo(id: number): Promise<void> {
    await api.delete(`/catalogo/historico/${id}`);
  }

  async gerarCatalogo(filtros: FiltrosCatalogo): Promise<string> {
    try {
      const response = await api.post<GerarCatalogoResponse>('/catalogo/gerar', filtros);
      return response.data.nomeArquivo;
    } catch (error: unknown) {
      console.error('❌ Erro detalhado ao gerar catálogo:');
      if (error && typeof error === 'object' && 'response' in error) {
        const axiosError = error as { response?: { status?: number; data?: unknown }; message?: string };
        console.error('Status:', axiosError.response?.status);
        console.error('Data:', axiosError.response?.data);
        console.error('Message:', axiosError.message);
      }
      logError('Full Error:', error);
      throw error;
    }
  }

  getDownloadUrl(nomeArquivo: string): string {
    return `/api/downloads/${nomeArquivo}`;
  }

  async baixarArquivo(nomeArquivo: string): Promise<void> {
    try {
      // Usar client da API para fazer o download
      const downloadUrl = `/downloads/${nomeArquivo}`;

      const response = await api.get(downloadUrl, {
        responseType: 'blob',
      });

      if (response.status !== 200) {
        console.error('❌ Resposta do servidor:', {
          status: response.status,
          statusText: response.statusText,
          url: downloadUrl
        });
        throw new Error(`Erro ao baixar arquivo: ${response.status} - ${response.statusText}`);
      }

      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      
      // Criar link temporário para download
      const link = document.createElement('a');
      link.href = url;
      link.download = nomeArquivo;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Limpar URL temporária
      window.URL.revokeObjectURL(url);
    } catch (error) {
      logError('Erro ao baixar arquivo:', error);
      throw error;
    }
  }
}

export const catalogoService = new CatalogoService();